// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"2fa9f88b","354":"1854413b","838":"65b76d2f"}[chunkId] + ".js";
};